import {NgModule} from '@angular/core';
import {ApolloModule, APOLLO_OPTIONS} from 'apollo-angular';
import {HttpLinkModule, HttpLink} from 'apollo-angular-link-http';
import {InMemoryCache} from 'apollo-cache-inmemory';
import {Credentials, User, GraphQLConfig} from 'realm-graphql-client';
const uri = 'https://provider-sync-cloud-staging.de1a.cloud.realm.io/graphql/%2FStagingSync-Provider'; // <-- add the URL of the GraphQL server here
const credentials = Credentials.usernamePassword('MobileTwo', 'Mobile_ING%9102');
export function createApollo(httpLink: HttpLink) {
  let url: any;
  User.authenticate(credentials, 'https://provider-sync-cloud-staging.de1a.cloud.realm.io/').then(user => {
      GraphQLConfig.create(user, '/StagingSync-Provider').then(config => {
        url = config.httpEndpoint;
        return {
          link: httpLink.create({uri}),
          cache: new InMemoryCache(),
        };
      });
  });
}

@NgModule({
  exports: [ApolloModule, HttpLinkModule],
  providers: [
    {
      provide: APOLLO_OPTIONS,
      useFactory: createApollo,
      deps: [HttpLink],
    },
  ],
})
export class GraphQLModule {}
